module.exports = __webpack_public_path__ + "img/card-no-img.7f70e1d0.png";